import { update, retrieve } from "framework/http/endpoint";
import { create as createRequest } from "framework/http/rest/jsonRequest";
import { UrlPathOfApiLocation } from "common/paths";
var UIContextApiUri = "".concat(UrlPathOfApiLocation, "/api/uicontext");
function apiGetUIContext() {
    return retrieve(UIContextApiUri);
}
function apiPutUIContext(uiQuery) {
    var request = createRequest(uiQuery);
    return update(UIContextApiUri, request);
}
export { apiGetUIContext, apiPutUIContext, };
